import script from "./ArgData.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgData.vue?vue&type=script&setup=true&lang=js"

import "./ArgData.vue?vue&type=style&index=0&id=3b0e6df6&lang=scss"

const __exports__ = script;

export default __exports__